import { render, staticRenderFns } from "./WorksheetTypeDefinitionIndex.vue?vue&type=template&id=a23a23fa"
import script from "./WorksheetTypeDefinitionIndex.vue?vue&type=script&lang=js"
export * from "./WorksheetTypeDefinitionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports